import React, { useEffect, useState } from 'react';
import styles from './ReportCardInfo.module.scss';
import { Icon, Popover, Tooltip } from 'antd';
import { reportIcons } from '../../../../constants/reportIcons';
import RoundedButton from '../../../../../../components/RoundedButton/RoundedButton';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { getSearchParams } from '../../../../helpers/searchParamsFns';
import { periodMainInfo } from '../../constants/periodMainInfo';
import { filtersData } from '../../../../constants/filtersData';
import { filterNames } from '../../../../constants/filterNames';
import useFilterState from '../../../../hooks/useFilterState';
import moment from 'moment';
import { ToggleShowInCutaway } from '../../../ToggleShowInCutaway/ToggleShowInCutaway';
import { ToggleUseTheFact } from '../../../ToggleUseTheFact/ToggleUseTheFact';
import { ReportCardCompleteCount } from '../ReportCardReqCount/ReportCardCompleteCount';

export const ReportCardInfo = ({
  title,
  totalRequests,
  link,
  periodInfo = {},
  showInCutawayState,
  useTheFactState,
  setShowInCutawayState,
  setUseTheFactState,
  factCount,
  planCount,
  closeCount,
}) => {
  const match = useRouteMatch();

  const location = useLocation();

  const searchParams = getSearchParams(location.search);

  const [period, setPeriod] = useState('За весь период');

  const isPeriodCard = title === 'Сроки выполнения';
  const isCompletedCard = title === 'Выполнено';

  const [[fromDate, toDate]] = useFilterState(
    filtersData[filterNames.createDate]
  );

  useEffect(() => {
    if (fromDate && toDate) {
      const formattedFromDate = moment(fromDate).format('D MMMM YYYY');
      const formattedToDate = moment(toDate).format('D MMMM YYYY');
      setPeriod({ from: formattedFromDate, to: formattedToDate });
    }
  }, [fromDate, toDate]);

  const handleShowInCutaway = () => {
    setShowInCutawayState((prev) => !prev);
  };

  const handleUseTheFact = () => {
    setUseTheFactState((prev) => !prev);
  };

  const getTooltipTitle = (value) => {
    if (typeof value !== 'string' && !useTheFactState) {
      return <Tooltip title="Факт">{value}</Tooltip>;
    } else if (typeof value !== 'string' && useTheFactState) {
      return <Tooltip title="Закрытые">{value}</Tooltip>;
    }
    const [plan, fact] = value.split('/');

    if (showInCutawayState && useTheFactState) {
      return (
        <>
          <Tooltip title="План">{plan}</Tooltip>/
          <Tooltip title="Закрытые">{fact}</Tooltip>
        </>
      );
    } else if (showInCutawayState) {
      return (
        <>
          <Tooltip title="План">{plan}</Tooltip>/
          <Tooltip title="Факт">{fact}</Tooltip>
        </>
      );
    }
    return <Tooltip title="Факт">{value}</Tooltip>;
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.titleWrap}>
          <span className={styles.anticon}>
            <Icon
              className={styles.icon}
              component={reportIcons[title]}
            />
          </span>
          <span className={styles.title}>{title}</span>
        </div>
        {isCompletedCard !== isPeriodCard && (
          <Popover
            overlayClassName={styles.popover}
            trigger="click"
            placement="bottomLeft"
            content={
              <div className={styles.filterButtonBlock}>
                <ToggleShowInCutaway
                  enabled={showInCutawayState}
                  onChange={handleShowInCutaway}
                />
                <br />
                <ToggleUseTheFact
                  enabled={useTheFactState}
                  onChange={handleUseTheFact}
                />
              </div>
            }
          >
            <Icon
              type="setting"
              className={styles.settings}
            />
          </Popover>
        )}
      </div>
      <div className={styles.main}>
        {!isPeriodCard && !isCompletedCard && (
          <span className={styles.totalRequests}>{totalRequests || 0}</span>
        )}
        {isPeriodCard && (
          <div className={styles.periodInfo}>
            {periodMainInfo.map((item) => (
              <React.Fragment key={item.id}>
                <span
                  style={{ color: item.color }}
                  className={item.totalRequestPeriodStyles}
                >
                  {getTooltipTitle(periodInfo?.[item.periodInfoKey] || 0)}
                </span>
                <span className={item.requestPeriodStyles}>{item.text}</span>
              </React.Fragment>
            ))}
          </div>
        )}
        {isCompletedCard && (
          <ReportCardCompleteCount
            factCount={factCount}
            planCount={planCount}
            closeCount={closeCount}
          />
        )}
        {!isPeriodCard && (
          <div className={styles.requestsPeriodWrapper}>
            {typeof period === 'object' ? (
              <>
                <span className={styles.requestsPeriod}>С {period.from}</span>
                <span className={styles.requestsPeriod}>По {period.to}</span>
              </>
            ) : (
              <span>{period}</span>
            )}
          </div>
        )}
      </div>
      <div className={styles.footer}>
        <Link
          className={styles.link}
          to={{
            pathname: `${match.url}/${link}`,
            search: `${searchParams}`,
          }}
        >
          <RoundedButton
            className={styles.moreBtn}
            text="Подробнее"
          />
        </Link>
      </div>
    </div>
  );
};
